import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-3 -10 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		opacity: .65,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.2 2.00005H1.80005",
			stroke: "#1A1D1E",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgMinus);
export { ForwardRef as ReactComponent };
